export default __webpack_public_path__ + "static/media/LogoBlue.fa0580b4.svg";